import { render, staticRenderFns } from "./cashback.vue?vue&type=template&id=6ed17d46&scoped=true&"
import script from "./cashback.vue?vue&type=script&lang=js&"
export * from "./cashback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed17d46",
  null
  
)

export default component.exports